import { movies } from "@/mocks/catalog";
import MovieCard from "@/components/feature/MovieCard";

const atmosphere = [
  { icon: "ri-moon-foggy-line", label: "环境先行", text: "用光线、声音与空间制造不安，情节往往缓慢累积。" },
  { icon: "ri-sound-module-line", label: "声音设计", text: "低语、敲击与静默的交替，是恐怖片最常见的心理武器。" },
  { icon: "ri-question-mark", label: "悬念收束", text: "真相通常在最后阶段揭开，留白与反转同样重要。" },
];

export default function HorrorSection() {
  const items = movies.filter((m) => m.genre === "恐怖片");

  return (
    <section id="horror" className="bg-foreground-950 py-16 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col gap-3">
          <span className="inline-flex w-fit items-center gap-2 rounded-full bg-accent-500/20 px-3 py-1 text-xs font-medium text-accent-200">
            <i className="ri-ghost-2-line"></i>
            恐怖片专区
          </span>
          <h2 className="font-heading text-2xl font-semibold text-background-50 md:text-3xl">
            恐怖片：把紧张感一点点交到你手里
          </h2>
          <p className="max-w-3xl text-sm leading-relaxed text-background-300 md:text-base">
            恐怖片并不只靠突然出现的画面，更多时候它先用环境让你意识到「有什么不对」，再让你自己等待那一刻到来。建议在光线充足、可以自由暂停的环境下观看，体验会更从容。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-4 md:grid-cols-3">
          {atmosphere.map((a) => (
            <div
              key={a.label}
              className="flex flex-col gap-2 rounded-lg border border-foreground-800 bg-foreground-900/70 p-5"
            >
              <span className="flex h-10 w-10 items-center justify-center rounded-md bg-accent-500/20 text-accent-300">
                <i className={`${a.icon} text-lg`}></i>
              </span>
              <h3 className="font-heading text-base font-semibold text-background-50">{a.label}</h3>
              <p className="text-sm leading-relaxed text-background-400">{a.text}</p>
            </div>
          ))}
        </div>

        <div className="mt-12 flex items-center gap-3">
          <h3 className="font-heading text-lg font-semibold text-background-50">代表作品</h3>
          <span className="h-px flex-1 bg-foreground-800"></span>
        </div>
        <div className="mt-6 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {items.map((movie) => (
            <MovieCard key={movie.id} movie={movie} />
          ))}
        </div>
      </div>
    </section>
  );
}